module.exports = new __parcel__URL__("DACI.3cadbee0.svg").toString();